module.exports = __webpack_public_path__ + "static/media/top-slide-4.6b186b4f.jpeg";